module.exports = __webpack_public_path__ + "img/main.747aeb38.png";